import { Component, OnInit, Output } from '@angular/core';
import { GameFiltrationDto } from '../../models/GameFiltrationDto';
import { GenericResponseContract } from 'projects/shared/models/GenericResponseContract';
import { GenericListContract } from 'projects/shared/models/GenericListContract';
import { ChildWorldService } from '../../services/child-world.service';
import { Globals } from 'projects/shared/models/Globals';
import { LoadedEntry } from '../../models/coloring-game.models';

declare var parentId : any;
declare var gameType:any;
@Component({
  selector: 'app-child-world-games-listing',
  templateUrl: './child-world-games-listing.component.html',
  styleUrls: []
})
export class ChildWorldGamesListingComponent implements OnInit {

  public gameLevels: any;
  public items: any;

  showFilterationCount: boolean = false;
  displayShowMoreButton: boolean = true;
  filter = false;
  gameType=gameType;
  ViewLocalizedResources: any;
  Filteration = new GameFiltrationDto(parentId,null, null, gameType=="mummy"?Globals.MummyGameListingCrop:Globals.ColorGameListingCrop);

  
  Count: Number;
  TotalCount: Number;

  entry: LoadedEntry;
  hideListingCards = false;

  constructor(private apiService: ChildWorldService) 
  {
    this.ViewLocalizedResources = Globals.ViewLocalizedResources;
    this.Filteration.Level = "All";
  }

  ngOnInit() {
    this.apiService.getGamesLevels(this.Filteration).subscribe((response: GenericResponseContract<GenericListContract<object>>) => {
      this.gameLevels = response.Data   
      this.getItems()
    });

  }

  getItems(isScroll = false){
    this.apiService.getGamesListingItems(this.Filteration).subscribe((response: GenericResponseContract<GenericListContract<object>>) => {
      this.items = isScroll ? this.items.concat(response.Data.ListItems) : response.Data.ListItems,
      this.Count = response.Data.Count,    
      this.TotalCount = response.Data.TotalCount,
      this.hideListingCards = false

      if ( response.Data.Count == this.items.length) {
        this.displayShowMoreButton = false;
      }
    }); 
  }

  resetFilter(event) {
    this.showFilterationCount = false;
    this.displayShowMoreButton=true;
    this.items=[];
    this.Filteration.Level = "All";
    this.Filteration.pageIndex=1;
    this.Filteration.ContainsStringValue = "";
    this.ngOnInit();
  }

  onSelectionChange() {
    this.filter = true;
    //this.onFilter();
  }

  noFilterApplied(): boolean{
    return (!this.Filteration.ContainsStringValue && !(this.Filteration.Level == "All"));      
  }

  onFilter() {
    if(this.filter){
      setTimeout(() => {
        this.showFilterationCount = this.noFilterApplied();
      }, 100);
      this.Filteration.pageIndex=1;
      this.displayShowMoreButton=true;
      this.getItems();      
      this.filter = false;
    }            
  }

  onShowMore() {
    this.Filteration.pageIndex++;
    this.getItems(true);
  }

  onScroll() {
    if(this.items != null && this.items){
      if (this.Filteration.pageIndex < 2 && this.items.length >= 8) {
        this.Filteration.pageIndex++;
        this.getItems(true);
      }
    }
  }

  startDrawing(entryDrawingGame: any, index: number){
    // this.entry = new LoadedEntry();
    // // this.entry.blackAndWhiteImage = entryDrawingGame.BlackAndWhiteImageUrl as HTMLImageElement;
    // this.entry.blackAndWhiteImage = <HTMLImageElement>document.getElementById('Image'+index);
    // this.entry.information = entryDrawingGame.Description;
    // this.entry.level = entryDrawingGame.ComplexityLevel;    
    // this.entry.title = entryDrawingGame.Title 
    // this.hideListingCards = true;
    // $("#ColoringGame").modal(); 
  }
}
